<template>
  <div>
    <div class="text-primary text-subtitle2 text-uppercase q-mb-sm">
      Cancel Request
    </div>
    <p v-if="request.creatorType === 'system'">
      This request cannot be cancelled because it was automatically created by the system.
    </p>
    <div v-else-if="request.creatorType === 'user'" class="row">
      <div class="col-7">
        Cancel the request if you no longer require new {{ platform }} posts.
      </div>
      <div class="col text-right">
        <cancel-request-btn :request="request" @canceled="$emit('canceled')" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ReconnectRequest } from '@/social/types';
import CancelRequestBtn from './CancelRequestBtn.vue';

export default defineComponent({
  emits: ['canceled'],
  components: { CancelRequestBtn },
  props: {
    request: {
      type: Object as () => ReconnectRequest,
      required: true,
    },
    platform: {
      type: String,
      required: true,
    },
  },
});
</script>
